import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/itemsForResource.js'
import axios from 'axios'
import { useAuthStore } from '@/stores/auth.js'

export const useFundraiserPublicStore = (id = 'default') => {
  return defineStore({
    id: `fundraiserPublic_${id}`,
    state: () => ({
      items: [],
      api: '/api/v1/fundraisers-public'
    }),
    getters: {
      ...getters,
      featured(state) {
        return state.items.filter(item => item.featured)
      },
    },
    actions: {
      ...actions,
      async fetchItemByOldId(oldId) {
        const { data } = await axios.get('/api/v1/fundraisers-public', {
          params: {
            old_id: oldId
          }
        })
        if(data.data && data.data.length > 0 && data.data[0].old_id === oldId) {
          return data.data[0]
        }
        return null
      },
      async startDonation(payload) {
        const { data } = await axios.post(this.api + '/' + payload.fundraiser_id + '/donations', payload)
        return data
      },
      async confirmDonation(payload) {
        const { data } = await axios.post(this.api + '/' + payload.fundraiser_id + '/donations/' + payload.donation_id + '/confirm', payload)
        return data
      },
      async subscribeToFundraiser(fundraiserId, payload) {
        const { data } = await axios.post(this.api + '/' + fundraiserId + '/subscribers', payload)
        return data
      }
    }
  })()
}
